import React, { useState, useEffect } from "react";
import { HiSearch, HiPencil, HiTrash } from "react-icons/hi";
import CreateEditRole from "./components/CreateEditRole";
import PermissionViewModal from "./components/PermissionViewModal";
import axios from "axios";
import DeleteRole from "./components/DeleteRole";
import Pagination from "Components/Pagination/Pagination";
import { usePermission } from "Context/PermissionContext";

function Role() {
  const [loading, setLoading] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchInput, setSearchInput] = useState("");

  const { permissions } = usePermission();
  const currentTabPermissions = permissions?.roleManagement?.permissions;

  const getAllRoles = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/role-permission/get-all-role`,
        {
          params: {
            search,
            page,
            limit,
          },
        }
      );

      if (res.data.success) {
        setRoleList(res.data.data);
        setTotalPages(res.data.pagination.totalPages);
      }

      setLoading(false);
    } catch (error) {
      console.log("Error fetching roles:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllRoles();
  }, [page, search]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(searchInput);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  const refreshList = () => getAllRoles();

  return (
    <div className="mt-5 w-full">
      {/* SEARCH + ADD BUTTON */}
      <div className="flex flex-col items-center justify-between space-y-4 rounded-2xl bg-white p-5 shadow-sm md:flex-row md:space-y-0">
        {/* Search Box */}
        <div className="relative w-full md:w-1/2">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
            <HiSearch className="h-5 w-5" color="#c51369" />
          </span>
          <input
            type="text"
            placeholder="Search role..."
            className="block w-full rounded-md border border-gray-300 px-4 py-2 pl-10 text-gray-700 transition-all focus:border-[#c51369] focus:ring-1 focus:ring-[#c51369]"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              setPage(1);
            }}
          />
        </div>

        {/* ADD BUTTON */}
        {currentTabPermissions?.create && (
          <button
            className="rounded-full bg-[#c51369] px-5 py-2 text-white shadow"
            onClick={() => {
              setEditData(null);
              setOpenModal(true);
            }}
          >
            + Create Role
          </button>
        )}
      </div>

      {/* TABLE SECTION */}
      <div className="mt-6 overflow-x-auto rounded-xl shadow-sm">
        <table className="w-full rounded-t-2xl text-left text-sm">
          <thead className="text-md bg-[#e0ced7] text-center uppercase tracking-wide text-navy-900">
            <tr>
              <th className="px-6 py-3">Sl No.</th>
              <th className="px-6 py-3">Created</th>
              <th className="px-6 py-3">Role Name</th>
              {/* <th className="px-6 py-3">Created By</th> */}
              <th className="px-6 py-3">Permissions</th>
              <th className="px-6 py-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <tr key={i} className="animate-pulse bg-white">
                  <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-6 rounded bg-gray-200"></div>
                  </td>
                  <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-20 rounded bg-gray-200"></div>
                  </td>
                  <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-28 rounded bg-gray-200"></div>
                  </td>
                  {/* <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-28 rounded bg-gray-200"></div>
                  </td> */}
                  <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-28 rounded bg-gray-200"></div>
                  </td>
                  <td className="border px-6 py-4 text-center">
                    <div className="h-4 w-16 rounded bg-gray-200"></div>
                  </td>
                </tr>
              ))
            ) : roleList.length === 0 ? (
              <tr>
                <td colSpan="5" className="py-4 text-center text-gray-500">
                  No roles found
                </td>
              </tr>
            ) : (
              roleList.map((row, index) => (
                <tr
                  key={row._id}
                  className="text-md group bg-white text-center tracking-wide"
                >
                  <td className="border px-6 py-4">{index + 1}</td>

                  <td className="border px-6 py-4">
                    <div className="flex flex-col leading-tight">
                      <span className="font-semibold text-navy-700">
                        {new Date(row.createdAt).toLocaleDateString("en-IN")}
                      </span>
                      <span className="text-sm text-gray-600">
                        {new Date(row.createdAt).toLocaleTimeString("en-IN", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                  </td>

                  <td className="border px-6 py-4 capitalize">
                    {row.rolename}
                  </td>

                  {/* Created By */}
                  {/* <td className="border px-6 py-4">
                    <div className="flex flex-col">
                      <span className="font-medium">
                        {row.createdBy || "-"}
                      </span>
                    </div>
                  </td> */}

                  {/* Permission Button */}
                  <td className="border px-6 py-4 text-center">
                    <button
                      className="rounded-md bg-purple-100 p-2 text-purple-600 hover:bg-purple-200"
                      onClick={() => {
                        setSelectedPermission(row.permission);
                        setOpenPermissionModal(true);
                      }}
                    >
                      👁 View
                    </button>
                  </td>

                  {/* ACTION BUTTONS */}
                  <td className="border px-6 py-4 text-center">
                    <div className="flex items-center justify-center gap-3">
                      {currentTabPermissions?.edit && (
                        <button
                          className="rounded-md bg-blue-100 p-2 text-[#c51369]"
                          onClick={() => {
                            setEditData(row);
                            setOpenModal(true);
                          }}
                        >
                          <HiPencil size={18} />
                        </button>
                      )}

                      {currentTabPermissions?.delete && (
                        <button
                          className="rounded-md bg-red-100 p-2 text-red-600 hover:bg-red-200"
                          onClick={() => DeleteRole(row._id, getAllRoles)}
                        >
                          <HiTrash size={18} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* MODALS */}
      <CreateEditRole
        open={openModal}
        onClose={() => setOpenModal(false)}
        editData={editData}
        refreshList={refreshList}
      />

      <PermissionViewModal
        open={openPermissionModal}
        onClose={() => setOpenPermissionModal(false)}
        permission={selectedPermission}
      />
      <Pagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={(newPage) => setPage(newPage)}
        showFirstLast={true}
      />
    </div>
  );
}

export default Role;
